exports.f = {}.propertyIsEnumerable;


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/core-js/modules/_object-pie.js
// module id = ../../../../core-js/modules/_object-pie.js
// module chunks = 1